import { Outlet } from 'react-router-dom';

import Sidebar from '../features/navigation/sidebar';
import MobileNav from '../features/navigation/mobile-nav';
import Footer from '../features/footer/footer';

import './styles/portal-shell.css';

// TSS vite/01 — authenticated layout shell for the client portal. Renders the
// desktop sidebar + the routed page (<Outlet>) + footer. On narrow screens the
// sidebar is replaced by a bottom bar (main views) plus a top-bar hamburger
// drawer (all views + logout) — see features/navigation + portal-shell.css.

export default function PortalShell() {
    return (
        <div className="portal-shell">
            <Sidebar />
            <div className="portal-shell__body">
                <MobileNav />
                <main className="portal-shell__main">
                    <Outlet />
                </main>
                <Footer />
            </div>
        </div>
    );
}
